import { render } from "./ShipmentFooter.vue?vue&type=template&id=1757a8d3"
import script from "./ShipmentFooter.vue?vue&type=script&lang=js"
export * from "./ShipmentFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__